import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators  } from '@angular/forms';
import { matchOtherValidator } from '../../shared/matchpass/matchpass';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Logging } from '../../logging';
import { ApiService } from '../../shared/api-service/api.service';
declare var jquery:any;
declare var $ :any;
declare var App:any;


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router) { 


}

changePasswordForm:  FormGroup;
showErrors:boolean = false;
loading: Boolean = false;
hasError: Boolean = false;
errorMessage: string ;
referralcode:any;


  ngOnInit() {

    this.changePasswordForm = new FormGroup({
      newpassword: new FormControl('', [
          Validators.minLength(6), 
          Validators.required
        ]),
        oldpassword: new FormControl('', [
          Validators.required
        ]),
      repeatPassword: new FormControl('', [
         Validators.required,
          matchOtherValidator('newpassword')
        ]),
    });


  }

  onSubmit(){
    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    if(this.changePasswordForm.valid){
      Logging.log(this.changePasswordForm.value);

      // Convert Form values into json 
      const formValues = JSON.parse(JSON.stringify(this.changePasswordForm.value));

      Logging.log(formValues);
     
      //Register the current user
      this.api.put('/users/' + this.auth.getUserID() + '/changepassword', formValues)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);

        //force log out of user to login again with new password
        this.auth.logout();
        return true;
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );

    }else{
      //Set loading to true to show loader
      this.loading = false;

      this.showErrors = true;
      Logging.log('Has Errors', this.changePasswordForm.value);
    }

  }

  clearErrors(){
    this.hasError = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/client/change-password/change-password.component.ts